import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import { onBlankLayout } from 'store/slices/themeSlice';

const AppRoute = ({ component: Component, routeKey, blankLayout, ...props }) => {
	const dispatch = useDispatch();

	useEffect(() => {
		const isBlank = blankLayout ? true : false
		dispatch(onBlankLayout(isBlank));
	}, [blankLayout])

	return (
		<Component {...props} />
	)
};

AppRoute.propTypes = {
	component: PropTypes.elementType.isRequired,
	routeKey: PropTypes.string,                  
	blankLayout: PropTypes.bool
};

export default AppRoute;
